// For now, assume a pitch of 1. It is a given that the diameter of a tube is the pitch divided by 1.25. The radius
// is the diameter divided by 2.
export const TUBE_RADIUS: number = 1 / 1.25 / 2;
